var map = {
	"./project.svg": "./src/icons/project.svg",
	"./svg/icon-add.svg": "./src/icons/svg/icon-add.svg",
	"./svg/icon-admin.svg": "./src/icons/svg/icon-admin.svg",
	"./svg/icon-back.svg": "./src/icons/svg/icon-back.svg",
	"./svg/icon-back2.svg": "./src/icons/svg/icon-back2.svg",
	"./svg/icon-beian.svg": "./src/icons/svg/icon-beian.svg",
	"./svg/icon-ben.svg": "./src/icons/svg/icon-ben.svg",
	"./svg/icon-bianji.svg": "./src/icons/svg/icon-bianji.svg",
	"./svg/icon-camera.svg": "./src/icons/svg/icon-camera.svg",
	"./svg/icon-camera1.svg": "./src/icons/svg/icon-camera1.svg",
	"./svg/icon-cardr.svg": "./src/icons/svg/icon-cardr.svg",
	"./svg/icon-chouqu.svg": "./src/icons/svg/icon-chouqu.svg",
	"./svg/icon-close.svg": "./src/icons/svg/icon-close.svg",
	"./svg/icon-closeeye.svg": "./src/icons/svg/icon-closeeye.svg",
	"./svg/icon-code.svg": "./src/icons/svg/icon-code.svg",
	"./svg/icon-config.svg": "./src/icons/svg/icon-config.svg",
	"./svg/icon-createTime.svg": "./src/icons/svg/icon-createTime.svg",
	"./svg/icon-dangdifill.svg": "./src/icons/svg/icon-dangdifill.svg",
	"./svg/icon-daohang.svg": "./src/icons/svg/icon-daohang.svg",
	"./svg/icon-delete.svg": "./src/icons/svg/icon-delete.svg",
	"./svg/icon-ding.svg": "./src/icons/svg/icon-ding.svg",
	"./svg/icon-duanxin.svg": "./src/icons/svg/icon-duanxin.svg",
	"./svg/icon-edit.svg": "./src/icons/svg/icon-edit.svg",
	"./svg/icon-editor.svg": "./src/icons/svg/icon-editor.svg",
	"./svg/icon-fengxian.svg": "./src/icons/svg/icon-fengxian.svg",
	"./svg/icon-fuwu.svg": "./src/icons/svg/icon-fuwu.svg",
	"./svg/icon-geren.svg": "./src/icons/svg/icon-geren.svg",
	"./svg/icon-guanli.svg": "./src/icons/svg/icon-guanli.svg",
	"./svg/icon-guocheng.svg": "./src/icons/svg/icon-guocheng.svg",
	"./svg/icon-hebi-cailiao.svg": "./src/icons/svg/icon-hebi-cailiao.svg",
	"./svg/icon-hebi-celiang.svg": "./src/icons/svg/icon-hebi-celiang.svg",
	"./svg/icon-hebi-chezhu.svg": "./src/icons/svg/icon-hebi-chezhu.svg",
	"./svg/icon-hebi-gongcheng.svg": "./src/icons/svg/icon-hebi-gongcheng.svg",
	"./svg/icon-hebi-gongju.svg": "./src/icons/svg/icon-hebi-gongju.svg",
	"./svg/icon-hebi-jiankong.svg": "./src/icons/svg/icon-hebi-jiankong.svg",
	"./svg/icon-hebi-jiaoyu.svg": "./src/icons/svg/icon-hebi-jiaoyu.svg",
	"./svg/icon-hebi-rili.svg": "./src/icons/svg/icon-hebi-rili.svg",
	"./svg/icon-hebi-shenhe.svg": "./src/icons/svg/icon-hebi-shenhe.svg",
	"./svg/icon-hebi-wenben.svg": "./src/icons/svg/icon-hebi-wenben.svg",
	"./svg/icon-hebi-zhaungji.svg": "./src/icons/svg/icon-hebi-zhaungji.svg",
	"./svg/icon-hebi-zhiliang.svg": "./src/icons/svg/icon-hebi-zhiliang.svg",
	"./svg/icon-hebi-zhongjie.svg": "./src/icons/svg/icon-hebi-zhongjie.svg",
	"./svg/icon-huodong.svg": "./src/icons/svg/icon-huodong.svg",
	"./svg/icon-jianguan.svg": "./src/icons/svg/icon-jianguan.svg",
	"./svg/icon-jiesuo.svg": "./src/icons/svg/icon-jiesuo.svg",
	"./svg/icon-laiyuan.svg": "./src/icons/svg/icon-laiyuan.svg",
	"./svg/icon-log.svg": "./src/icons/svg/icon-log.svg",
	"./svg/icon-menu.svg": "./src/icons/svg/icon-menu.svg",
	"./svg/icon-more.svg": "./src/icons/svg/icon-more.svg",
	"./svg/icon-mudedi.svg": "./src/icons/svg/icon-mudedi.svg",
	"./svg/icon-open.svg": "./src/icons/svg/icon-open.svg",
	"./svg/icon-openeye.svg": "./src/icons/svg/icon-openeye.svg",
	"./svg/icon-oss.svg": "./src/icons/svg/icon-oss.svg",
	"./svg/icon-pinglun.svg": "./src/icons/svg/icon-pinglun.svg",
	"./svg/icon-pingwei.svg": "./src/icons/svg/icon-pingwei.svg",
	"./svg/icon-platform.svg": "./src/icons/svg/icon-platform.svg",
	"./svg/icon-platform1.svg": "./src/icons/svg/icon-platform1.svg",
	"./svg/icon-project.svg": "./src/icons/svg/icon-project.svg",
	"./svg/icon-renyuan.svg": "./src/icons/svg/icon-renyuan.svg",
	"./svg/icon-role.svg": "./src/icons/svg/icon-role.svg",
	"./svg/icon-rt.svg": "./src/icons/svg/icon-rt.svg",
	"./svg/icon-shanchu.svg": "./src/icons/svg/icon-shanchu.svg",
	"./svg/icon-shanchu1.svg": "./src/icons/svg/icon-shanchu1.svg",
	"./svg/icon-shang.svg": "./src/icons/svg/icon-shang.svg",
	"./svg/icon-shezhi.svg": "./src/icons/svg/icon-shezhi.svg",
	"./svg/icon-shoucang.svg": "./src/icons/svg/icon-shoucang.svg",
	"./svg/icon-shoucangfill.svg": "./src/icons/svg/icon-shoucangfill.svg",
	"./svg/icon-shouye.svg": "./src/icons/svg/icon-shouye.svg",
	"./svg/icon-shouye1.svg": "./src/icons/svg/icon-shouye1.svg",
	"./svg/icon-sousuo.svg": "./src/icons/svg/icon-sousuo.svg",
	"./svg/icon-sql.svg": "./src/icons/svg/icon-sql.svg",
	"./svg/icon-submitTime.svg": "./src/icons/svg/icon-submitTime.svg",
	"./svg/icon-suoding.svg": "./src/icons/svg/icon-suoding.svg",
	"./svg/icon-system.svg": "./src/icons/svg/icon-system.svg",
	"./svg/icon-time.svg": "./src/icons/svg/icon-time.svg",
	"./svg/icon-tishi.svg": "./src/icons/svg/icon-tishi.svg",
	"./svg/icon-tixing.svg": "./src/icons/svg/icon-tixing.svg",
	"./svg/icon-toubiaoren.svg": "./src/icons/svg/icon-toubiaoren.svg",
	"./svg/icon-tousu.svg": "./src/icons/svg/icon-tousu.svg",
	"./svg/icon-tubiao.svg": "./src/icons/svg/icon-tubiao.svg",
	"./svg/icon-upload.svg": "./src/icons/svg/icon-upload.svg",
	"./svg/icon-user.svg": "./src/icons/svg/icon-user.svg",
	"./svg/icon-users.svg": "./src/icons/svg/icon-users.svg",
	"./svg/icon-w.svg": "./src/icons/svg/icon-w.svg",
	"./svg/icon-xia.svg": "./src/icons/svg/icon-xia.svg",
	"./svg/icon-xiangmu.svg": "./src/icons/svg/icon-xiangmu.svg",
	"./svg/icon-xiangqu.svg": "./src/icons/svg/icon-xiangqu.svg",
	"./svg/icon-xiangqufill.svg": "./src/icons/svg/icon-xiangqufill.svg",
	"./svg/icon-yin.svg": "./src/icons/svg/icon-yin.svg",
	"./svg/icon-yujing.svg": "./src/icons/svg/icon-yujing.svg",
	"./svg/icon-zhaobiaoagent.svg": "./src/icons/svg/icon-zhaobiaoagent.svg",
	"./svg/icon-zhaobiaoren.svg": "./src/icons/svg/icon-zhaobiaoren.svg",
	"./svg/icon-zhedie.svg": "./src/icons/svg/icon-zhedie.svg",
	"./svg/icon-zonghe.svg": "./src/icons/svg/icon-zonghe.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons sync recursive \\.svg$";